import React from "react";
import CourbesStatChart from "./CourbesStatChart.jsx";

/**
 * Besoin en eau journalier : 12 courbes (horizon x statistique), via
 * CourbesStatChart. Cochées à l'ouverture : Moyen et Maximum.
 */
export default function EauChart({ data, uniteElevage = false }) {
  // En élevage le besoin s'exprime par tête et non en lame d'eau.
  const unite = uniteElevage ? "L/tête/j" : "mm/j";
  return (
    <CourbesStatChart
      data={data}
      prefixe="besoin"
      cleDate="date_affichage"
      unite={unite}
      nomAxe={`Besoin en eau (${unite})`}
      statsParDefaut={["moy", "max"]}
      // En élevage, l'axe Y démarre au minimum réel des données (arrondi à
      // l'entier inférieur) : l'échelle automatique écrasait les écarts.
      yMinAuto={uniteElevage}
    />
  );
}
